import React from "react";
import { Loader } from "lucide-react";

const LoadingSpinner: React.FC = () => (
  <div className="fixed inset-0 z-50 flex items-center justify-center w-full h-full bg-white bg-opacity-90 dark:bg-zinc-900 dark:bg-opacity-90">
    <Loader className="w-10 h-10 text-black animate-spin" />
  </div>
);

export default LoadingSpinner;